import React, { useState } from 'react';
import { PaystackScript } from '../components/Payment/PaystackScript';
import { Check, Star, TrendingUp, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
export const AIPowerBundle = () => {
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState<'pending' | 'form' | 'success'>('pending');
  const [reference, setReference] = useState('');
  const [formStep, setFormStep] = useState(1);
  const [formData, setFormData] = useState({
    // Page 1
    fullName: '',
    email: '',
    phone: '',
    profession: '',
    cityState: '',
    hasCreatedWebsite: '',
    aiComfortLevel: '',
    device: [] as string[],
    learningGoal: [] as string[],
    biggestFrustration: [] as string[],
    oneThingToWalkAway: '',
    // Page 2
    interestInMasterclass: '',
    priceWillingness: '',
    investmentFactor: [] as string[],
    monetizationIntent: '',
    audienceToServe: [] as string[],
    monthlyIncomeGoal: '',
    preferredClassStyle: '',
    preferredClassTime: [] as string[],
    practicePreference: [] as string[],
    paymentPlanHelp: '',
    permissionForUpdates: ''
  });
  const handlePaymentSuccess = (ref: string) => {
    setReference(ref);
    setPaymentStatus('form');
    window.scrollTo(0, 0);
  };
  const handleFormChange = (e: any) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => {
        const currentArray = prev[name as keyof typeof prev] as string[];
        if (checked) {
          return {
            ...prev,
            [name]: [...currentArray, value]
          };
        } else {
          return {
            ...prev,
            [name]: currentArray.filter(item => item !== value)
          };
        }
      });
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
  const handleNextStep = () => {
    setFormStep(2);
    window.scrollTo(0, 0);
  };
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const data = {
      fullName: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      profession: formData.profession,
      city: formData.cityState,
      websiteExperience: formData.hasCreatedWebsite,
      aiComfort: formData.aiComfortLevel,
      device: Array.isArray(formData.device) ? formData.device.join(', ') : formData.device,
      goal: Array.isArray(formData.learningGoal) ? formData.learningGoal.join(', ') : formData.learningGoal,
      frustration: Array.isArray(formData.biggestFrustration) ? formData.biggestFrustration.join(', ') : formData.biggestFrustration,
      oneThing: formData.oneThingToWalkAway,
      masterclassInterest: formData.interestInMasterclass,
      priceRange: formData.priceWillingness,
      investTrigger: Array.isArray(formData.investmentFactor) ? formData.investmentFactor.join(', ') : formData.investmentFactor,
      monetize: formData.monetizationIntent,
      audience: Array.isArray(formData.audienceToServe) ? formData.audienceToServe.join(', ') : formData.audienceToServe,
      monthlyGoal: formData.monthlyIncomeGoal,
      classStyle: formData.preferredClassStyle,
      classTime: Array.isArray(formData.preferredClassTime) ? formData.preferredClassTime.join(', ') : formData.preferredClassTime,
      practicePreference: Array.isArray(formData.practicePreference) ? formData.practicePreference.join(', ') : formData.practicePreference,
      paymentPlan: formData.paymentPlanHelp,
      permission: formData.permissionForUpdates
    };
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbx3X11ZnhJ9Qas0Ylp8l7U1OHsjyTtx-u-Zp-mhsA3blmP3aIJBhB4TfhcLmnSFAgtg5A/exec', {
        method: 'POST',
        body: JSON.stringify(data)
      });
      const result = await response.json();
      if (result.result === 'success') {
        setPaymentStatus('success');
        window.location.href = 'https://chat.whatsapp.com/KuVilCGv5Zn8KqDmdOUoee';
      } else {
        alert('Submission failed. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Submission failed. Please try again.');
    }
  };
  const initializePayment = () => {
    if (!(window as any).PaystackPop) {
      alert('Payment system loading, please try again in a moment');
      return;
    }
    const handler = (window as any).PaystackPop.setup({
      key: 'pk_live_c2f71547b29d95243a012d9ef2f8e03485d942e7',
      email: 'customer@email.com',
      amount: 5000 * 100,
      currency: 'NGN',
      callback: (response: any) => {
        handlePaymentSuccess(response.reference);
      },
      onClose: () => {
        console.log('Payment closed');
      }
    });
    handler.openIframe();
  };
  if (paymentStatus === 'success') {
    return <div className="min-h-screen flex items-center justify-center" style={{
      backgroundColor: '#F9F9F9'
    }} data-id="element-2291" data-mp="2dsk8ntze1a2k">
        <div className="text-center p-8" data-id="element-2292" data-mp="25gtis64wxfi">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center" style={{
          backgroundColor: '#1AB9C8'
        }} data-id="element-2293" data-mp="3taqajuc5i1cz">
            <Check size={40} style={{
            color: '#FFFFFF'
          }} data-id="element-2294" data-mp="3p953wqq7mjb8" />
          </div>
          <h1 className="text-3xl font-bold mb-4" style={{
          color: '#0B1F3F'
        }} data-id="element-2295" data-mp="3kbd3t9fevqvy">
            Redirecting to WhatsApp...
          </h1>
          <p style={{
          color: '#333333'
        }} data-id="element-2296" data-mp="gsjqmxqjp42b">
            Your ebook will be delivered shortly!
          </p>
        </div>
      </div>;
  }
  if (paymentStatus === 'form') {
    return <div className="min-h-screen py-12" style={{
      backgroundColor: '#F9F9F9'
    }} data-id="element-2297" data-mp="73i9v5c6eina">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-2298" data-mp="14inw7anandvy">
          <div className="mb-8 text-center" data-id="element-2299" data-mp="14jywv1lg05iu">
            <h1 className="text-3xl font-bold mb-4" style={{
            color: '#0B1F3F'
          }} data-id="element-2300" data-mp="zs7f9gk9la4u">
              Almost There! Let's Get You Set Up
            </h1>
            <p className="text-lg" style={{
            color: '#333333'
          }} data-id="element-2301" data-mp="1iq96rkem3sdu">
              Fill this short form so we know a bit about you and can deliver
              your ebook straight to your WhatsApp
            </p>
          </div>

          {/* Progress Bar */}
          <div className="mb-8" data-id="element-2302" data-mp="1dvwkz3pny4yx">
            <div className="h-2 rounded-full" style={{
            backgroundColor: '#E5E5E5'
          }} data-id="element-2303" data-mp="zxojcihomfhf">
              <div className="h-full rounded-full transition-all duration-300" style={{
              backgroundColor: '#F4B400',
              width: formStep === 1 ? '50%' : '100%'
            }} data-id="element-2304" data-mp="14whzyjs9mmlt" />
            </div>
            <p className="text-center mt-2 text-sm" style={{
            color: '#333333'
          }} data-id="element-2305" data-mp="uxtt8h5qdtxf">
              Step {formStep} of 2
            </p>
          </div>

          <form id="aiForm" onSubmit={formStep === 2 ? handleFormSubmit : e => {
          e.preventDefault();
          handleNextStep();
        }} className="space-y-6 p-8 rounded-lg" style={{
          backgroundColor: '#FFFFFF',
          border: '2px solid #E5E5E5'
        }} data-id="element-2306" data-mp="2pcmm48f8c6lo">
            {formStep === 1 ? <>
                <h2 className="text-2xl font-bold mb-6" style={{
              color: '#0B1F3F'
            }} data-id="element-2307" data-mp="nfm9pyiwgma5">
                  Basic Info & Digital Readiness
                </h2>

                <div data-id="element-2308" data-mp="xd0bcs05z6ie">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2309" data-mp="xch3630bfwhk">
                    Full Name *
                  </label>
                  <input type="text" name="fullName" value={formData.fullName} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2310" data-mp="16dorbs94bgxx" />
                </div>

                <div data-id="element-2311" data-mp="38638gp3u8hda">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2312" data-mp="387e9ih5wfb0p">
                    Email Address *
                  </label>
                  <input type="email" name="email" value={formData.email} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2313" data-mp="2ia152mru6r9d" />
                </div>

                <div data-id="element-2314" data-mp="2w1xswemh2ezy">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2315" data-mp="2w2h47chma550">
                    Phone Number *
                  </label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2316" data-mp="23d0cyi5qguad" />
                </div>

                <div data-id="element-2317" data-mp="2dchjf1st7c7e">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2318" data-mp="2dcr7uky7hbaz">
                    Current Profession *
                  </label>
                  <input type="text" name="profession" value={formData.profession} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2319" data-mp="3op1ro1uz1x3a" />
                </div>

                <div data-id="element-2320" data-mp="13d6mixg7xa7y">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2321" data-mp="13cofr6vxjdls">
                    City/State *
                  </label>
                  <input type="text" name="cityState" value={formData.cityState} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2322" data-mp="uci9a4ynfdw4" />
                </div>

                <div data-id="element-2323" data-mp="kf43czacq7i2">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2324" data-mp="kgonduz1i81o">
                    Have you ever created a website before? *
                  </label>
                  <select name="hasCreatedWebsite" value={formData.hasCreatedWebsite} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2325" data-mp="2eq91jo2o5rq0">
                    <option value="" data-id="element-2326" data-mp="3j13op46bjs4y">Select...</option>
                    <option value="Yes" data-id="element-2327" data-mp="3j2oi2qgwd518">Yes</option>
                    <option value="No" data-id="element-2328" data-mp="1sqfe5idn6az">No</option>
                  </select>
                </div>

                <div data-id="element-2329" data-mp="3syi2sx4rs4u3">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2330" data-mp="3t02xqnuzxpsh">
                    Comfort level with AI tools *
                  </label>
                  <select name="aiComfortLevel" value={formData.aiComfortLevel} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2331" data-mp="30bf6mbnkg670">
                    <option value="" data-id="element-2332" data-mp="3a6z24wy7x2v8">Select...</option>
                    <option value="Beginner" data-id="element-2333" data-mp="2mhwbizllvzol">Beginner</option>
                    <option value="Intermediate" data-id="element-2334" data-mp="2mgcu35o7ril8">Intermediate</option>
                    <option value="Advanced" data-id="element-2335" data-mp="2hj35ttck9cyz">Advanced</option>
                  </select>
                </div>

                <div data-id="element-2336" data-mp="x0936flroqh5">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2337" data-mp="11sadhvzdk74j">
                    Device you work with? * (Select all that apply)
                  </label>
                  <div className="space-y-2" data-id="element-2338" data-mp="s27m207wj18b">
                    {['Laptop (Windows)', 'Laptop (Mac)', 'Desktop Computer', 'Tablet', 'Smartphone Only', 'Smartphone + occasional laptop access', 'I currently have no device'].map(option => <label key={option} className="flex items-center" data-id="element-2339" data-mp="1kremj4qx20w7">
                        <input type="checkbox" name="device" value={option} checked={formData.device.includes(option)} onChange={handleFormChange} className="mr-2" data-id="element-2340" data-mp="16rnbncvp50mf" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2341" data-mp="1ar5nzk9gc3dn">
                          {option}
                        </span>
                      </label>)}
                  </div>
                </div>

                <div data-id="element-2342" data-mp="2207bnuru9dbw">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2343" data-mp="21zfh8n9z9ln7">
                    What exactly do you want to achieve with this AI Skills
                    Class? * (Choose one or multiple)
                  </label>
                  <div className="space-y-2" data-id="element-2344" data-mp="1nbuit6o1salm">
                    {['Learn how to use AI for everyday productivity', 'Automate repetitive tasks in my work/business', 'Learn how to use AI tools for content creation', 'Build AI-powered workflows (emails, proposals, research, etc.)', 'Create digital products/services using AI', 'Improve my career or become more employable', 'Start a freelance or consulting business using AI', 'Learn how to train or specialize AI for my field', 'Understand AI well enough to teach others', 'Not sure yet — I just want to learn'].map(option => <label key={option} className="flex items-center" data-id="element-2345" data-mp="33p1bzgnxpaqq">
                        <input type="checkbox" name="learningGoal" value={option} checked={formData.learningGoal.includes(option)} onChange={handleFormChange} className="mr-2" data-id="element-2346" data-mp="2ys191emdso3u" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2347" data-mp="3b8k4qemzcici">
                          {option}
                        </span>
                      </label>)}
                  </div>
                </div>

                <div data-id="element-2348" data-mp="3kydfjdfastfp">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2349" data-mp="3l0zkr6epuwur">
                    Biggest frustration with learning digital skills? * (Select
                    up to 4)
                  </label>
                  <div className="space-y-2" data-id="element-2350" data-mp="2x8sumozl3m3s">
                    {["Too much information — I don't know where to start", 'No one to guide me step-by-step', "I learn but I can't apply it practically", "I don't have enough time", 'Tools feel too complex', 'Training programs are too expensive', 'I learn fast but forget when I try to do it alone', 'My device is slow or limited', 'Poor internet connection', "I'm overwhelmed… everything feels new"].map(option => <label key={option} className="flex items-center" data-id="element-2351" data-mp="1qh7s7x4m8zcx">
                        <input type="checkbox" name="biggestFrustration" value={option} checked={formData.biggestFrustration.includes(option)} onChange={handleFormChange} disabled={formData.biggestFrustration.length >= 4 && !formData.biggestFrustration.includes(option)} className="mr-2" data-id="element-2352" data-mp="1li4msbkq4r4f" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2353" data-mp="29co4zyzbvsm6">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2354" data-mp="2i5ri2662a3ga">
                    Selected: {formData.biggestFrustration.length}/4
                  </p>
                </div>

                <div data-id="element-2355" data-mp="2s2dxgffmc2ax">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2356" data-mp="2n5vtviw0ya06">
                    If you could walk away from this class with ONE thing fully
                    done, what would it be? * (Pick only 1)
                  </label>
                  <select name="oneThingToWalkAway" value={formData.oneThingToWalkAway} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2357" data-mp="2wt9md3fpow26">
                    <option value="" data-id="element-2358" data-mp="2o0o9g3yrhjl9">Select one...</option>
                    <option value="My first automated workflow" data-id="element-2359" data-mp="2nz3eid8jbymv">
                      My first automated workflow
                    </option>
                    <option value="My first AI-created digital product" data-id="element-2360" data-mp="2e3ta5iunzf5x">
                      My first AI-created digital product
                    </option>
                    <option value="My personal AI assistant set up" data-id="element-2361" data-mp="25222w9kh709y">
                      My personal AI assistant set up
                    </option>
                    <option value="My business processes automated" data-id="element-2362" data-mp="292dpvt0b9col">
                      My business processes automated
                    </option>
                    <option value="My AI portfolio built" data-id="element-2363" data-mp="auhtz7rm03nb">
                      My AI portfolio built
                    </option>
                    <option value="My AI content creation system" data-id="element-2364" data-mp="5w6kiy587v5m">
                      My AI content creation system
                    </option>
                    <option value="My first AI-powered income stream" data-id="element-2365" data-mp="u7efgi3qk4z">
                      My first AI-powered income stream
                    </option>
                    <option value="My resume/LinkedIn profile optimized with AI" data-id="element-2366" data-mp="tlr1jbhtkic9">
                      My resume/LinkedIn profile optimized with AI
                    </option>
                    <option value="My business marketing system automated" data-id="element-2367" data-mp="kkknd92n7jm6">
                      My business marketing system automated
                    </option>
                    <option value="Clarity and confidence using AI tools" data-id="element-2368" data-mp="399isui33an67">
                      Clarity and confidence using AI tools
                    </option>
                    <option value="A full 30-day action plan I can follow" data-id="element-2369" data-mp="1ktso54ctfrj2">
                      A full 30-day action plan I can follow
                    </option>
                    <option value="Not sure — I want recommendations" data-id="element-2370" data-mp="1tse2enb98ke1">
                      Not sure — I want recommendations
                    </option>
                  </select>
                </div>

                <button type="submit" className="w-full py-4 rounded-md font-bold text-white text-lg transition-all hover:opacity-90" style={{
              backgroundColor: '#0B1F3F'
            }} data-id="element-2371" data-mp="23jii5p8r899x">
                  Next →
                </button>
              </> : <>
                <h2 className="text-2xl font-bold mb-6" style={{
              color: '#0B1F3F'
            }} data-id="element-2372" data-mp="2hii3oo0z081v">
                  Buying Power & Learning Style
                </h2>

                <div data-id="element-2373" data-mp="i7gz5tchgkb7">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2374" data-mp="n47gek00xly7">
                    Interest in full practical masterclass *
                  </label>
                  <select name="interestInMasterclass" value={formData.interestInMasterclass} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2375" data-mp="2l0xs9wrbz829">
                    <option value="" data-id="element-2376" data-mp="2tu1460mbvcus">Select...</option>
                    <option value="Very Interested" data-id="element-2377" data-mp="262vl7cl3c4g9">Very Interested</option>
                    <option value="Somewhat Interested" data-id="element-2378" data-mp="264ylqqjvdfz8">
                      Somewhat Interested
                    </option>
                    <option value="Not Interested" data-id="element-2379" data-mp="2g1ukw5nvopr4">Not Interested</option>
                  </select>
                </div>

                <div data-id="element-2380" data-mp="2b16unm7h4cxy">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2381" data-mp="2b0ng8fh186oo">
                    Price range you would consider? * (₦100,000–₦250,000)
                  </label>
                  <select name="priceWillingness" value={formData.priceWillingness} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2382" data-mp="3mjhtuqikcfnb">
                    <option value="" data-id="element-2383" data-mp="z97kzeiqaka4">Select...</option>
                    <option value="₦100,000 – ₦130,000" data-id="element-2384" data-mp="zasfx58yg58i">
                      ₦100,000 – ₦130,000
                    </option>
                    <option value="₦130,000 – ₦160,000" data-id="element-2385" data-mp="1rxlizu9thglo">
                      ₦130,000 – ₦160,000
                    </option>
                    <option value="₦160,000 – ₦190,000" data-id="element-2386" data-mp="1vzgjwxnu5ryx">
                      ₦160,000 – ₦190,000
                    </option>
                    <option value="₦190,000 – ₦220,000" data-id="element-2387" data-mp="1i7afu9xyjbfu">
                      ₦190,000 – ₦220,000
                    </option>
                    <option value="₦220,000 – ₦250,000" data-id="element-2388" data-mp="1n4shrgdk4qec">
                      ₦220,000 – ₦250,000
                    </option>
                    <option value="I can pay in installments" data-id="element-2389" data-mp="2fmxtcxgvrupk">
                      I can pay in installments
                    </option>
                    <option value="I can only join if there is a scholarship/discount" data-id="element-2390" data-mp="2vxzzzngm41ec">
                      I can only join if there is a scholarship/discount
                    </option>
                  </select>
                </div>

                <div data-id="element-2391" data-mp="2n2k5d4819i7p">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2392" data-mp="2r5gjahmmoq5b">
                    What would make you confidently invest in a premium hands-on
                    program? * (Choose at most 2)
                  </label>
                  <div className="space-y-2" data-id="element-2393" data-mp="245ip2n913vog">
                    {['Step-by-step practical learning', 'Real-life projects I can use immediately', 'A mentor or expert I can ask questions', 'Templates, tools & resources included', 'A clear promise of skill mastery', 'Proof that others got results', 'Certificate + portfolio', 'Live sessions + recordings', 'Community support + accountability', 'Money-back guarantee', 'A clear path to earning with AI', 'Flexible payment options'].map(option => <label key={option} className="flex items-center" data-id="element-2394" data-mp="1qy1odzf8uyfd">
                        <input type="checkbox" name="investmentFactor" value={option} checked={formData.investmentFactor.includes(option)} onChange={handleFormChange} disabled={formData.investmentFactor.length >= 2 && !formData.investmentFactor.includes(option)} className="mr-2" data-id="element-2395" data-mp="1mxhrmwyl1wtr" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2396" data-mp="2akznp4ovrh2j">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2397" data-mp="2jl5z8l10q6z2">
                    Selected: {formData.investmentFactor.length}/2
                  </p>
                </div>

                <div data-id="element-2398" data-mp="p8y6nec6626g">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2399" data-mp="pa9d5lx01o19">
                    Do you want to use this skill to earn money? *
                  </label>
                  <select name="monetizationIntent" value={formData.monetizationIntent} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2400" data-mp="2pao27v8nxyg4">
                    <option value="" data-id="element-2401" data-mp="2ybm5gbba21xn">Select...</option>
                    <option value="Yes" data-id="element-2402" data-mp="2y9137l72hjzd">Yes</option>
                    <option value="No" data-id="element-2403" data-mp="339fedc3yta1m">No</option>
                    <option value="Maybe" data-id="element-2404" data-mp="338mb4l47t2o8">Maybe</option>
                  </select>
                </div>

                <div data-id="element-2405" data-mp="3d09ya9tqnxjw">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2406" data-mp="3czqiaynnfj8i">
                    Audience you plan to serve? * (Choose 2-3)
                  </label>
                  <div className="space-y-2" data-id="element-2407" data-mp="3m1q0huaegtd1">
                    {['Small business owners', 'Students / young people', 'Creatives (writers, designers, content creators)', 'NGOs / nonprofits', 'Coaches / consultants', 'Corporate teams', 'Schools / teachers', 'E-commerce businesses', 'Real estate', 'Health & wellness', 'Churches / ministries', 'Anyone who needs digital transformation', 'Not sure yet — I need help choosing'].map(option => <label key={option} className="flex items-center" data-id="element-2408" data-mp="16csx5jo5156p">
                        <input type="checkbox" name="audienceToServe" value={option} checked={formData.audienceToServe.includes(option)} onChange={handleFormChange} disabled={formData.audienceToServe.length >= 3 && !formData.audienceToServe.includes(option)} className="mr-2" data-id="element-2409" data-mp="11don6qte33fb" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2410" data-mp="1palwyd3gsyzv">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2411" data-mp="2hrer9xkidroy">
                    Selected: {formData.audienceToServe.length}/3
                  </p>
                </div>

                <div data-id="element-2412" data-mp="1wjvxj1gtilau">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2413" data-mp="1wjdwzsn4hkx4">
                    Monthly income goal using AI-assisted skills *
                  </label>
                  <input type="text" name="monthlyIncomeGoal" value={formData.monthlyIncomeGoal} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2414" data-mp="1nmbx1uqs4t1a" />
                </div>

                <div data-id="element-2415" data-mp="2k9gkdvg3e2pe">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2416" data-mp="2k9zyt26ja8yo">
                    Preferred class style *
                  </label>
                  <select name="preferredClassStyle" value={formData.preferredClassStyle} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2417" data-mp="2bgn17mxiyj69">
                    <option value="" data-id="element-2418" data-mp="340bv1062e8lw">Select...</option>
                    <option value="Live" data-id="element-2419" data-mp="3dbzt5ep8q0wa">Live</option>
                    <option value="Recorded" data-id="element-2420" data-mp="39bpap2k9hi0j">Recorded</option>
                    <option value="Hybrid" data-id="element-2421" data-mp="39b7g0ad8zbuq">Hybrid</option>
                  </select>
                </div>

                <div data-id="element-2422" data-mp="3n2c9svtxp9x5">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2423" data-mp="3n4yl96jy49kn">
                    Preferred Class Time * (Choose 2)
                  </label>
                  <div className="space-y-2" data-id="element-2424" data-mp="2qcuwbuopmjkw">
                    {['Weekday mornings', 'Weekday afternoons', 'Weekday evenings', 'Saturday mornings', 'Saturday afternoons', 'Saturday evenings', 'Sunday afternoon', 'Fully online & flexible (self-paced + live support)'].map(option => <label key={option} className="flex items-center" data-id="element-2425" data-mp="2zbyij7j6bf3m">
                        <input type="checkbox" name="preferredClassTime" value={option} checked={formData.preferredClassTime.includes(option)} onChange={handleFormChange} disabled={formData.preferredClassTime.length >= 2 && !formData.preferredClassTime.includes(option)} className="mr-2" data-id="element-2426" data-mp="jlc8qeyg9ziw" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2427" data-mp="qoty4y2p68wq">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2428" data-mp="10mq31851k7me">
                    Selected: {formData.preferredClassTime.length}/2
                  </p>
                </div>

                <div data-id="element-2429" data-mp="7zn8er3hkh1f">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2430" data-mp="7wrcf8b782fm">
                    How do you prefer to practice? * (Choose 2)
                  </label>
                  <div className="space-y-2" data-id="element-2431" data-mp="3gex8xurq9e73">
                    {['Guided step-by-step exercises', 'Real project challenges', 'Assignments with feedback', 'Interactive live sessions', 'Solo practice following templates', 'Group practice / paired learning', 'Watching video tutorials', 'Doing it myself with occasional support', 'A combination of everything'].map(option => <label key={option} className="flex items-center" data-id="element-2432" data-mp="38wpjywm4necf">
                        <input type="checkbox" name="practicePreference" value={option} checked={formData.practicePreference.includes(option)} onChange={handleFormChange} disabled={formData.practicePreference.length >= 2 && !formData.practicePreference.includes(option)} className="mr-2" data-id="element-2433" data-mp="33vig38n3uzb1" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2434" data-mp="2q4d91lher4qo">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2435" data-mp="2g7s573h4jzof">
                    Selected: {formData.practicePreference.length}/2
                  </p>
                </div>

                <div data-id="element-2436" data-mp="277c6s8f8niqf">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2437" data-mp="2785dj9e7688k">
                    If a payment plan would help you join faster *
                  </label>
                  <select name="paymentPlanHelp" value={formData.paymentPlanHelp} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2438" data-mp="3u341ttonhcu">
                    <option value="" data-id="element-2439" data-mp="3cbpimzkka4qa">Select...</option>
                    <option value="Yes" data-id="element-2440" data-mp="3caxug9tan9a1">Yes</option>
                    <option value="No" data-id="element-2441" data-mp="3h37jlnml45b9">No</option>
                  </select>
                </div>

                <div data-id="element-2442" data-mp="32eukihs7a6cj">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2443" data-mp="32fe21xdxusq1">
                    Permission to receive updates on upcoming advanced
                    masterclasses *
                  </label>
                  <select name="permissionForUpdates" value={formData.permissionForUpdates} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2444" data-mp="2xeyp36xkjn8l">
                    <option value="" data-id="element-2445" data-mp="29smq4ou5eebs">Select...</option>
                    <option value="Yes" data-id="element-2446" data-mp="2nrcos8wm8m29">Yes</option>
                    <option value="No" data-id="element-2447" data-mp="2ns5o4ot8w9ad">No</option>
                  </select>
                </div>

                <div className="flex gap-4" data-id="element-2448" data-mp="2irhyo7ko00i9">
                  <button type="button" onClick={() => setFormStep(1)} className="flex-1 py-4 rounded-md font-bold transition-all hover:opacity-90" style={{
                backgroundColor: '#E5E5E5',
                color: '#333333'
              }} data-id="element-2449" data-mp="2ium6dexc9edo">
                    ← Back
                  </button>
                  <button type="submit" className="flex-1 py-4 rounded-md font-bold text-white transition-all hover:opacity-90" style={{
                backgroundColor: '#F4B400'
              }} data-id="element-2450" data-mp="32g8rrrjtf8w0">
                    Submit & Join WhatsApp Group
                  </button>
                </div>
              </>}
          </form>
        </div>
      </div>;
  }
  return <>
      <PaystackScript data-id="element-2451" data-mp="33x8kt2fnpb5q" />
      <div className="min-h-screen" style={{
      backgroundColor: '#F9F9F9'
    }} data-id="element-2452" data-mp="33vp2l6afwq1b">
        {/* Hero Section with Floating Comments */}
        <section className="relative py-20 overflow-hidden" data-id="element-2453" data-mp="2uwk4u26pd0q7">
          <div className="absolute inset-0 z-0" data-id="element-2454" data-mp="2py8yi1fm98cq">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="AI Power Bundle" className="w-full h-full object-cover grayscale opacity-20" data-id="element-2455" data-mp="2pxgzshqq2ui8" />
          </div>

          {/* Floating Comments - Left Side */}
          <div className="absolute left-4 md:left-8 top-32 z-20 space-y-6 hidden md:block" data-id="element-2456" data-mp="2c6vigxgx2smg">
            <div className="p-4 rounded-lg shadow-lg max-w-[220px] animate-float-left" style={{
            backgroundColor: '#F4B400',
            color: '#FFFFFF',
            animationDelay: '0s'
          }} data-id="element-2457" data-mp="277r8w5q2ysvl">
              <p className="font-bold text-sm mb-1" data-id="element-2458" data-mp="1x9uvf79o7lub">Adebayo Okonkwo ✓</p>
              <p className="text-xs" data-id="element-2459" data-mp="1xbxmzvqh1n15">
                This transformed how I work. AI is no longer intimidating!
              </p>
            </div>
            <div className="p-4 rounded-lg shadow-lg max-w-[220px] animate-float-left" style={{
            backgroundColor: '#F4B400',
            color: '#FFFFFF',
            animationDelay: '1s'
          }} data-id="element-2460" data-mp="1s3ptazplwze0">
              <p className="font-bold text-sm mb-1" data-id="element-2461" data-mp="221m57tqdbyd6">Chidinma Nwosu ✓</p>
              <p className="text-xs" data-id="element-2462" data-mp="14fonvznq5z2t">
                Finally, AI skills I can actually use in my business!
              </p>
            </div>
          </div>

          {/* Floating Comments - Right Side */}
          <div className="absolute right-4 md:right-8 top-32 z-20 space-y-6 hidden md:block" data-id="element-2463" data-mp="1ed2xpgf57pm5">
            <div className="p-4 rounded-lg shadow-lg max-w-[220px] animate-float-right" style={{
            backgroundColor: '#F4B400',
            color: '#FFFFFF',
            animationDelay: '0.5s'
          }} data-id="element-2464" data-mp="1j4b2u09fwoti">
              <p className="font-bold text-sm mb-1" data-id="element-2465" data-mp="qmgxucfalbn8">Oluwaseun Adeyemi ✓</p>
              <p className="text-xs" data-id="element-2466" data-mp="imkhauymyt59">
                Cut my content creation time in half. Game changer!
              </p>
            </div>
            <div className="p-4 rounded-lg shadow-lg max-w-[220px] animate-float-right" style={{
            backgroundColor: '#F4B400',
            color: '#FFFFFF',
            animationDelay: '1.5s'
          }} data-id="element-2467" data-mp="dnpl8rbnr837">
              <p className="font-bold text-sm mb-1" data-id="element-2468" data-mp="nfvl0n85itsy">Ngozi Okafor ✓</p>
              <p className="text-xs" data-id="element-2469" data-mp="3vudsonu6k7c1">
                Best investment I made this year. Simple and actionable!
              </p>
            </div>
          </div>

          <div className="container mx-auto px-4 relative z-10" data-id="element-2470" data-mp="9mxbzy2sd36x">
            <div className="max-w-4xl mx-auto text-center" data-id="element-2471" data-mp="9kb7667a51se">
              <h1 className="text-4xl md:text-6xl font-bold mb-6" style={{
              color: '#0B1F3F'
            }} data-id="element-2472" data-mp="4mhzf8qbvzq0">
                The 2026 AI Power Bundle for Professionals
              </h1>
              <p className="text-xl md:text-2xl mb-8" style={{
              color: '#333333'
            }} data-id="element-2473" data-mp="1g1oh6dyxza6r">
                Everything you need to master AI for work, content, brand, and
                productivity — in one actionable bundle
              </p>
              <button onClick={initializePayment} className="px-8 py-4 rounded-lg font-bold text-white text-lg transition-all hover:opacity-90 shadow-lg" style={{
              backgroundColor: '#0B1F3F'
            }} data-id="element-2474" data-mp="1elkh3ejbqkb3">
                Grab a Copy for ₦5,000
              </button>
            </div>
          </div>
        </section>

        {/* Sales Copy Section - Freytag Storytelling */}
        <section className="py-16" style={{
        backgroundColor: '#FFFFFF'
      }} data-id="element-2475" data-mp="1xk53wue6n3ix">
          <div className="container mx-auto px-4" data-id="element-2476" data-mp="1xic5219t9nlh">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2477" data-mp="21kflz5f91ke5">
              <p className="text-lg md:text-xl mb-6" style={{
              color: '#333333'
            }} data-id="element-2478" data-mp="2pbkx57a8voi4">
                <strong style={{
                color: '#0B1F3F'
              }} data-id="element-2479" data-mp="2u2b58sa225gi">
                  You're watching everyone else leverage AI
                </strong>{' '}
                while you're still stuck doing everything manually. Your
                competitors are creating content in minutes. Your peers are
                automating their workflows. And you? You're drowning in tasks
                that AI could handle in seconds.
              </p>
              <p className="text-lg md:text-xl mb-6" style={{
              color: '#333333'
            }} data-id="element-2480" data-mp="sgb638ve2lrt">
                <strong style={{
                color: '#0B1F3F'
              }} data-id="element-2481" data-mp="1k54ptgl02h65">
                  The pressure is real.
                </strong>{' '}
                Clients expect faster turnarounds. Your business demands more
                efficiency. Your personal brand needs consistent content. But
                every "AI tutorial" you find is either too technical, too
                expensive, or too time-consuming to implement.
              </p>
              <p className="text-lg md:text-xl mb-6" style={{
              color: '#333333'
            }} data-id="element-2482" data-mp="232pdwlfxxbpp">
                <strong style={{
                color: '#0B1F3F'
              }} data-id="element-2483" data-mp="3lstkfif2e9g7">
                  What if you could master AI in one weekend?
                </strong>{' '}
                Not with complex coding or expensive courses — but with simple,
                copy-paste prompts and tools designed specifically for Nigerian
                professionals, educators, and business owners like you.
              </p>
              <p className="text-lg md:text-xl mb-6" style={{
              color: '#333333'
            }} data-id="element-2484" data-mp="dj1q64xdyki9">
                <strong style={{
                color: '#1AB9C8'
              }} data-id="element-2485" data-mp="i9i3lp17i64m">
                  The 2026 AI Power Bundle
                </strong>{' '}
                gives you everything: AI skills that matter, personal branding
                strategies, time-saving tools, ready-to-use prompts for content
                and photos — all for less than the cost of lunch.
              </p>
              <p className="text-lg md:text-xl font-bold" style={{
              color: '#0B1F3F'
            }} data-id="element-2486" data-mp="2scedpips2qyz">
                Stop watching from the sidelines. Start leading with AI — today.
              </p>
            </div>
          </div>
        </section>

        {/* What's Inside Section */}
        <section className="py-16" style={{
        backgroundColor: '#F9F9F9'
      }} data-id="element-2487" data-mp="2xbiky3t56emo">
          <div className="container mx-auto px-4" data-id="element-2488" data-mp="3b35lifu4a9b9">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{
            color: '#0B1F3F'
          }} data-id="element-2489" data-mp="3b1ujakgbl9m9">
              What's Inside the Ebook
            </h2>
            <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-2490" data-mp="3l0a9ml7iweup">
              {[{
              icon: <Star size={24} data-id="element-2491" data-mp="3g3tlhr0bq0hm" />,
              title: 'AI Skills Every Professional Must Learn in 2025',
              desc: 'Stay ahead of the curve and make yourself indispensable'
            }, {
              icon: <TrendingUp size={24} data-id="element-2492" data-mp="1lq22i0w3u49i" />,
              title: 'How to Build a Personal Brand With AI in 7 Steps',
              desc: 'Position yourself as an expert and attract opportunities'
            }, {
              icon: <Zap size={24} data-id="element-2493" data-mp="64rpej7glgyx" />,
              title: 'AI Tools That Will Cut Your Work Time in Half',
              desc: 'Work faster, smarter, and more efficiently'
            }, {
              icon: <Check size={24} data-id="element-2494" data-mp="3sjjj0eg14djr" />,
              title: '10 AI Prompts for Content Generation',
              desc: 'Create content instantly with professional tone'
            }, {
              icon: <Check size={24} data-id="element-2495" data-mp="3jl7hhhdmjvcj" />,
              title: '10 AI Prompts for Your Photo Editing',
              desc: 'Edit and enhance images like a pro without software'
            }].map((item, i) => <div key={i} className="p-6 rounded-lg transition-all hover:shadow-lg" style={{
              border: '2px solid #1AB9C8'
            }} data-id="element-2496" data-mp="39nb9uzjwbij6" data-mpi={i}>
                  <div className="flex items-start gap-4" data-id="element-2497" data-mp="12tza5p097m1s">
                    <div className="p-3 rounded-full" style={{
                  backgroundColor: '#1AB9C8',
                  color: '#FFFFFF'
                }} data-id="element-2498" data-mp="17udb6n3ftvqb">
                      {item.icon}
                    </div>
                    <div data-id="element-2499" data-mp="3mtxpo7kmxm1d">
                      <h3 className="text-xl font-bold mb-2" style={{
                    color: '#0B1F3F'
                  }} data-id="element-2500" data-mp="3i0uu5twas2ij">
                        {item.title}
                      </h3>
                      <p style={{
                    color: '#333333'
                  }} data-id="element-2501" data-mp="382ylr9uqvlo4">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Urgency Section */}
        <section className="py-16" style={{
        backgroundColor: '#F4B400'
      }} data-id="element-2502" data-mp="2u3ff6lhl0idx">
          <div className="container mx-auto px-4" data-id="element-2503" data-mp="xavndnqznzhi">
            <div className="max-w-3xl mx-auto text-center" data-id="element-2504" data-mp="x9kitlppynpc">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{
              color: '#0B1F3F'
            }} data-id="element-2505" data-mp="sbapzhrgvz6w">
                Limited Time Offer!
              </h2>
              <p className="text-xl mb-8" style={{
              color: '#333333'
            }} data-id="element-2506" data-mp="zth6wyn05ndx">
                Grab it today for ₦5,000 — price increases to ₦25,000 by the end
                of 2025. Secure your copy while it's still affordable!
              </p>
              <button onClick={initializePayment} className="px-8 py-4 rounded-lg font-bold text-lg transition-all hover:opacity-90 shadow-lg" style={{
              backgroundColor: '#0B1F3F',
              color: '#FFFFFF'
            }} data-id="element-2507" data-mp="1ejokp122ei8a">
                Grab Your Copy Now
              </button>
            </div>
          </div>
        </section>

        {/* Upsell Section */}
        <section className="py-16" style={{
        backgroundColor: '#FFFFFF'
      }} data-id="element-2508" data-mp="vurqsyakxrql">
          <div className="container mx-auto px-4" data-id="element-2509" data-mp="22almvm42616c">
            <div className="max-w-3xl mx-auto p-8 rounded-lg" style={{
            border: '2px solid #1AB9C8'
          }} data-id="element-2510" data-mp="22c50f4ybxy4f">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center" style={{
              color: '#0B1F3F'
            }} data-id="element-2511" data-mp="227sos67ydxby">
                Ready to Go Deeper?
              </h2>
              <p className="text-lg mb-6" style={{
              color: '#333333'
            }} data-id="element-2512" data-mp="2c5qcmslwhs41">
                Loved the bundle? Join our full practical masterclass where
                you'll create your own AI-assisted website, automation systems,
                content strategies, and personal brand framework. Limited seats,
                hands-on guidance, and 50+ ready-to-use prompts.
              </p>
              <div className="text-center" data-id="element-2513" data-mp="2uvoj54a1vd5k">
                <Link to="/ai-masterclass" data-id="element-2514" data-mp="2uwzubp5trn6p">
                  <button className="px-8 py-4 rounded-lg font-bold text-white text-lg transition-all hover:opacity-90" style={{
                  backgroundColor: '#1AB9C8'
                }} data-id="element-2515" data-mp="2zvuccovyx7pr">
                    Learn More About Masterclass
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <style data-id="element-2516" data-mp="x6j9eid53mlv">{`
          @keyframes float-left {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            50% { transform: translateY(-15px) translateX(5px); }
          }
          @keyframes float-right {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            50% { transform: translateY(-15px) translateX(-5px); }
          }
          .animate-float-left {
            animation: float-left 4s ease-in-out infinite;
          }
          .animate-float-right {
            animation: float-right 4s ease-in-out infinite;
          }
        `}</style>
      </div>
    </>;
};